import { v4 as uuidv4 } from 'uuid';
import { AxiosResponse } from 'axios';
import useApi, { CheckStatusType } from './apiService';

export interface ISession {
  id: string;
  createdAt: number;
  lastActive: number;
  isReady: boolean;
  email?: string;
  queuePosition?: number;
}

const SESSION_KEY = 'fanaticka_session';

const createSession = (email: string): ISession => {
  const session: ISession = {
    id: uuidv4(),
    createdAt: Date.now(),
    lastActive: Date.now(),
    isReady: false,
    email,
  };
  saveSession(session);
  return session;
};

const getSession = (): ISession | null => {
  const sessionStr = sessionStorage.getItem(SESSION_KEY);
  if (!sessionStr) return null;
  return JSON.parse(sessionStr);
};

const updateSession = (session: ISession): void => {
  session.lastActive = Date.now();
  saveSession(session);
};

const clearSession = (): void => {
  sessionStorage.removeItem(SESSION_KEY);
};

const saveSession = (session: ISession): void => {
  sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));
};

const checkSessionStatus = async (sessionId: string, email: string) => {
  try {
    const { sessionApi } = useApi();
    const response = (await sessionApi.checkStatus(sessionId, email)) as AxiosResponse<CheckStatusType>;

    return {
      added: !!response?.data?.added,
      blocked: !!response?.data?.blocked,
      isReady: !!response?.data?.isReady,
      position: response?.data?.position || 0,
      userExist: !!response?.data?.userExist,
    };
  } catch (error) {
    return { added: false, blocked: false, isReady: false, position: 0, userExist: false };
  }
};

export const sessionService = {
  createSession,
  getSession,
  updateSession,
  clearSession,
  checkSessionStatus,
};

export const heartBeat = async (sessionId: string, email: string) => {
  const { sessionApi } = useApi();
  try {
    await sessionApi.heartBeat(sessionId, email);
  } catch (e) {
    console.error(e);
  }
};

export const sessionConfirm = async (sessionId: string, email: string) => {
  const { sessionApi } = useApi();
  try {
    const response = await sessionApi.sessionConfirm(sessionId, email);
    return response?.data?.success;
  } catch (e) {
    console.error(e);
  }
};

export const sessionLeave = async (sessionId: string, email: string) => {
  const { sessionApi } = useApi();
  try {
    await sessionApi.sessionsLeave(sessionId, email);
  } catch (e) {
    console.error(e);
  }
};